import type { UseFormRegister, UseFormSetValue, UseFormWatch, FieldErrors } from 'react-hook-form';
import type { SubscribeFormValues } from '../SubscribeFormSchema';
import type { ScheduleDay } from '../../../config/types';
import { getAvailableDays, getEventsForDay } from '../scheduleHelpers';

interface Props {
  register: UseFormRegister<SubscribeFormValues>;
  setValue: UseFormSetValue<SubscribeFormValues>;
  watch: UseFormWatch<SubscribeFormValues>;
  errors: FieldErrors<SubscribeFormValues>;
  schedule: ScheduleDay[];
}

/** Cascading day + time select for livestream-reminder campaigns — ported from
 *  otm_so_2026_06's ServiceForm.js date/time <select> pair, driven by campaign config instead
 *  of a hardcoded per-app schedule. Changing the day resets an already-picked time that's no
 *  longer valid for it. */
export default function ScheduleFields({ register, setValue, watch, errors, schedule }: Props) {
  const selectedDate = watch('date');
  const days = getAvailableDays(schedule);
  const times = getEventsForDay(schedule, selectedDate);

  return (
    <>
      <div className="form-row">
        <label className="form-label" htmlFor="date">
          Wybierz dzień*
        </label>
        <select
          id="date"
          className="form-input"
          {...register('date', {
            onChange: () => setValue('time', ''),
          })}
        >
          <option value="">Wybierz dzień</option>
          {days.map((day) => (
            <option key={day.value} value={day.value}>
              {day.label}
            </option>
          ))}
        </select>
        {errors.date && <div className="form-error">{errors.date.message}</div>}
      </div>
      <div className="form-row">
        <label className="form-label" htmlFor="time">
          Wybierz godzinę*
        </label>
        <select id="time" className="form-input" disabled={!selectedDate} {...register('time')}>
          <option value="">{selectedDate ? 'Wybierz godzinę' : 'Najpierw wybierz dzień'}</option>
          {times.map((time) => (
            <option key={time.value} value={time.value}>
              {time.label}
            </option>
          ))}
        </select>
        {errors.time && <div className="form-error">{errors.time.message}</div>}
      </div>
    </>
  );
}
